export enum AIAgentRolesEnum {
  SYSTEM = "system",
  USER = "user",
}
